import React, { useEffect, useState } from "react";
import "./index.scss";
import PageHeader from "../../../adminCompenents/listComponents/Layout";
import CardContainer from "../../../adminCompenents/listComponents/UI/CardContainer";
import ExportButton from "../../../adminCompenents/listComponents/UI/ExportButton";
import AddButton from "../../../adminCompenents/listComponents/UI/AddButton";
import SearchFilterBar from "../../../adminCompenents/listComponents/UI/SearchFilterBar";
import DataTable from "../../../adminCompenents/listComponents/UI/DataTable";
import DataCards from "../../../adminCompenents/listComponents/UI/DataCards";
import Pagination from "../../../adminCompenents/listComponents/UI/Pagination";
import PromoService from "../../../services/promo"; // 🔹 nouveau service
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import { showSuccessToaster } from "../../../adminCompenents/listComponents/UI/toaster/success";
import { exportCSV } from "../../../adminCompenents/utils";
import DrawerForm from "../../../adminCompenents/listComponents/UI/DrawerForm";
import { FiCheckSquare } from "react-icons/fi";
import { FaBan } from "react-icons/fa";

const promoService = new PromoService();

const PromoPage = () => {
  const [promos, setPromos] = useState([]);
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const perPage = 5;
  const [filters, setFilters] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [editPromo, setEditPromo] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);

  const filterFields = [
    { name: "title", label: "Titre", placeholder: "Rechercher..." },
  ];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await promoService.getAllPromos();
      setPromos(res?.data || []);
    } catch (error) {
      showErrorToaster(
        error.response?.data?.message || "Erreur lors du chargement des promos"
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const filtered = promos.filter(
    (p) =>
      p.title?.toLowerCase().includes(search.toLowerCase()) &&
      (filters?.title
        ? p.title.toLowerCase().includes(filters.title.toLowerCase())
        : true)
  );

  const totalPages = Math.ceil(filtered.length / perPage);
  const paginated = filtered.slice((page - 1) * perPage, page * perPage);

  const handleStatus = async (id) => {
    setIsLoading(true);
    try {
      const response = await promoService.togglePromoStatus(id);
      const updatedPromo = response?.data || response;
      setPromos((prev) => prev.map((p) => (p._id === id ? updatedPromo : p)));
    } catch (error) {
      showErrorToaster(
        error.response?.data?.message || "Erreur lors du changement de status"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    { header: "Titre", accessor: "title" },
    {
      header: "Status",
      accessor: "status",
      Cell: (value) => (
        <span
          className={`badge ${value ? "bg-successstyle" : "bg-dangerstyle"}`}>
          {value ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      header: "Date début",
      accessor: "startDate",
      Cell: (value) => new Date(value).toLocaleDateString(),
    },
    {
      header: "Date fin",
      accessor: "endDate",
      Cell: (value) => new Date(value).toLocaleDateString(),
    },
    {
      header: "Pourcentage",
      accessor: "percentage",
      Cell: (value) => `${value}%`,
    },
  ];

  const rowActions = (row) => [
    {
      label: "Edit",
      onClick: () => {
        setEditPromo(row);
        setShowDrawer(true);
      },
    },
    {
      label: row.status ? (
        <FaBan style={{ color: "#EE0202" }} />
      ) : (
        <FiCheckSquare style={{ color: "#00AC0E" }} />
      ),
      onClick: () => handleStatus(row._id),
    },
  ];

  const fields = [
    {
      name: "title",
      label: "Titre",
      placeholder: "Entrez le titre",
      required: true,
    },
    {
      name: "percentage",
      label: "Pourcentage",
      type: "number",
      placeholder: "Ex: 20",
      required: true,
    },
    { name: "startDate", label: "Date début", type: "date", required: true },
    { name: "endDate", label: "Date fin", type: "date", required: true },
  ];

  const handleSubmit = async (formData, editPromo = null) => {
    try {
      if (editPromo) {
        const updated = await promoService.updatePromo(editPromo._id, formData);
        setPromos((prev) =>
          prev.map((p) => (p._id === editPromo._id ? updated.data : p))
        );
        showSuccessToaster("Code promo modifié avec succès !");
      } else {
        const newPromo = await promoService.createPromo(formData);
        setPromos((prev) => [...prev, newPromo.data]);
        showSuccessToaster("Code promo créé avec succès !");
      }
      setShowDrawer(false);
      setEditPromo(null);
    } catch (error) {
      showErrorToaster(
        error.response?.data?.message || "Erreur lors de la soumission"
      );
    }
  };

  return (
    <div>
      <PageHeader
        title="Codes Promo"
        breadcrumb={[{ label: "Accueil", href: "/" }, { label: "Codes Promo" }]}
      />
      <CardContainer>
        <div className="d-flex justify-content-between align-items-center mb-3 m-4">
          <h5 className="title-liste">Liste des codes promo</h5>
          <div className="d-flex gap-2">
            <ExportButton
              onClick={() =>
                exportCSV(
                  ["title", "percentage", "status", "startDate", "endDate"],
                  paginated,
                  "promos.csv"
                )
              }
            />
            <AddButton label="Code Promo" onClick={() => setShowDrawer(true)} />
          </div>
        </div>

        <hr className="hr-table" />
        <SearchFilterBar
          fields={filterFields}
          onSearch={setSearch}
          onFilter={setFilters}
        />
        <hr className="hr-table" />

        {isMobile ? (
          <DataCards
            columns={columns}
            data={paginated}
            keyField="id"
            rowActions={rowActions}
          />
        ) : (
          <DataTable
            columns={columns}
            data={paginated}
            keyField="id"
            rowActions={rowActions}
          />
        )}

        <Pagination
          currentPage={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </CardContainer>

      <DrawerForm
        show={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setEditPromo(null);
        }}
        title={editPromo ? "Modifier un code promo" : "Créer un code promo"}
        fields={fields}
        initialData={editPromo}
        onSubmit={(data) => handleSubmit(data, editPromo)}
      />
    </div>
  );
};

export default PromoPage;
